/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApprovedAccessOrderBy } from './ApprovedAccessOrderBy';
import {
    ApprovedAccessOrderByFromJSON,
    ApprovedAccessOrderByFromJSONTyped,
    ApprovedAccessOrderByToJSON,
    ApprovedAccessOrderByToJSONTyped,
} from './ApprovedAccessOrderBy';
import type { SortOrder } from './SortOrder';
import {
    SortOrderFromJSON,
    SortOrderFromJSONTyped,
    SortOrderToJSON,
    SortOrderToJSONTyped,
} from './SortOrder';

/**
 * 
 * @export
 * @interface ApprovedAccessOrderByPaginationQuery
 */
export interface ApprovedAccessOrderByPaginationQuery {
    /**
     * 
     * @type {any}
     * @memberof ApprovedAccessOrderByPaginationQuery
     */
    pageNumber?: any | null;
    /**
     * 
     * @type {any}
     * @memberof ApprovedAccessOrderByPaginationQuery
     */
    pageSize?: any | null;
    /**
     * 
     * @type {SortOrder}
     * @memberof ApprovedAccessOrderByPaginationQuery
     */
    sortOrder?: SortOrder;
    /**
     * 
     * @type {ApprovedAccessOrderBy}
     * @memberof ApprovedAccessOrderByPaginationQuery
     */
    orderField?: ApprovedAccessOrderBy;
}



/**
 * Check if a given object implements the ApprovedAccessOrderByPaginationQuery interface.
 */
export function instanceOfApprovedAccessOrderByPaginationQuery(value: object): value is ApprovedAccessOrderByPaginationQuery {
    return true;
}

export function ApprovedAccessOrderByPaginationQueryFromJSON(json: any): ApprovedAccessOrderByPaginationQuery {
    return ApprovedAccessOrderByPaginationQueryFromJSONTyped(json, false);
}

export function ApprovedAccessOrderByPaginationQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApprovedAccessOrderByPaginationQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'pageNumber': json['pageNumber'] === undefined ? undefined : json['pageNumber'] === null ? null : json['pageNumber'],
        'pageSize': json['pageSize'] === undefined ? undefined : json['pageSize'] === null ? null : json['pageSize'],
        'sortOrder': json['sortOrder'] == null ? undefined : SortOrderFromJSON(json['sortOrder']),
        'orderField': json['orderField'] == null ? undefined : ApprovedAccessOrderByFromJSON(json['orderField']),
    };
}

export function ApprovedAccessOrderByPaginationQueryToJSON(json: any): ApprovedAccessOrderByPaginationQuery {
    return ApprovedAccessOrderByPaginationQueryToJSONTyped(json, false);
}

export function ApprovedAccessOrderByPaginationQueryToJSONTyped(value?: ApprovedAccessOrderByPaginationQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageNumber': value['pageNumber'],
        'pageSize': value['pageSize'],
        'sortOrder': SortOrderToJSON(value['sortOrder']),
        'orderField': ApprovedAccessOrderByToJSON(value['orderField']),
    };
}

